import Typography from '@alltrails/core/components/Typography';
import Link from '@alltrails/denali/components/Link';
import { FormattedMessage } from 'react-intl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import Button from '@alltrails/denali/components/Button';
import LinkedInIcon from '@alltrails/layout/components/socialIcons/LinkedInIcon';
import FacebookIcon from '@alltrails/layout/components/socialIcons/FacebookIcon';
import InstagramIcon from '@alltrails/layout/components/socialIcons/InstagramIcon';
import TikTokIcon from '@alltrails/layout/components/socialIcons/TikTokIcon';
import TwitterIcon from '@alltrails/layout/components/socialIcons/TwitterIcon';
import useIsMobileSizedScreen from '@alltrails/denali/hooks/useIsMobileSizedScreen';
import styles from './styles/styles.module.scss';

// Desktop: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A10751&t=ek28S5j6RKi1yX4H-1
// Mobile: https://www.figma.com/file/XrlDM2ZdWXmlnl7ZXUicGn/Press%2FAbout%2F404?node-id=1701%3A11274&t=ek28S5j6RKi1yX4H-1

const br = () => <br />;

export default function ContactUs() {
  const isMobile = useIsMobileSizedScreen();
  const languageRegionCode = useLanguageRegionCode();
  const imageFileName = `https://cdn-assets.alltrails.com/press/contact_us/PR-KIT-IMG-${languageRegionCode}${isMobile ? '-M' : '-D'}`;

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.left}>
          <Typography component="h2" variant="heading500" className={styles.header}>
            <FormattedMessage defaultMessage="Contact us" />
          </Typography>

          <div className={styles.info}>
            <div>
              <Typography component="h3" variant="heading400" className={styles.subHeader}>
                <FormattedMessage defaultMessage="Press contact" />
              </Typography>
              <Link className={styles.email} href="mailto:press@alltrails.com">
                <FormattedMessage defaultMessage="Email" />
              </Link>
            </div>
            <div>
              <Typography component="h3" variant="heading400" className={styles.subHeader}>
                <FormattedMessage defaultMessage="Address" />
              </Typography>
              <Typography component="div" variant="paragraph200">
                <p className={styles.address}>
                  530 Bush Street, 9th Floor <br /> San Francisco, CA, 94108
                </p>
                <div className={styles.links}>
                  <LinkedInIcon openInNewTab />
                  <FacebookIcon openInNewTab />
                  <InstagramIcon openInNewTab />
                  <TikTokIcon openInNewTab />
                  <TwitterIcon openInNewTab />
                </div>
              </Typography>
            </div>
          </div>
        </div>
        <div className={styles.download}>
          <picture>
            <source srcSet={`${imageFileName}.avif`} type="image/avif" />
            <source srcSet={`${imageFileName}.webp`} type="image/webp" />
            <img className={styles.img} loading="lazy" src={`${imageFileName}.jpg`} alt="" />
          </picture>
          <div className={styles.presskit}>
            <Typography component="h2" variant="heading500" className={styles.presstext}>
              <FormattedMessage defaultMessage="Download <br></br> our press kit" values={{ br }} />
            </Typography>
            <Button
              linkInfo={{
                href: 'https://www.dropbox.com/scl/fo/g0rqlov7junzuljyjk8uw/ADFx0onwClg9g0aOb0r2nNA?rlkey=90qesjadcvk95dryzo7ho85yw&st=bbeeaedn&dl=0'
              }}
              testId="view-assets"
              text={<FormattedMessage defaultMessage="View assets" />}
              variant="elevated"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
